export const pageOrder = {
  ACCEPT: 0,
  PERSONAL: 1,
  CONTACT: 2,
  COVER: 3,
  QUOTE: 4,
  ABOUT_YOU_DISCLOSURE: 5,
  ABOUT_YOU_QUESTIONS: 6,
  REVIEW_APPLICATION: 7,
  PP_ONLINE_POLICY_OUTCOME: 8,
  PP_CONTACT: 9, //* PP is Purchase Path
  PP_ONLINE_PAYMENT: 10,
  PP_CONFIRMATION: 11,
  PP_POLICY_OUTCOME_DECLINE: 12,
  /* Retrieve quote loading needs to be the last page in the index. We need the retrieve loading page to be present
   inside the ContactCenterLayout.jsx so that the initial state is kicked in and once we get retrieve information from API, then we add to the state
   Adding all the pages of outcome outside the sequence */
  RETRIEVE_QUOTE_LOADING: 13,
  RETRIEVE_DECLINE: 14,
  RETRIEVE_EXPIRED: 15,
  RETRIEVE_REFERRED_UW: 16,
  RETRIEVE_BOUND: 17,
  APPLICATION_ALREADY_DECLINED: 18,
};

export const pageOrderCC = {
  SCRIPT: 0,
  PERSONAL: 1,
  CONTACT: 2,
  COVER: 3,
  QUOTE: 4,
  ABOUT_YOU_DISCLOSURE: 5,
  ABOUT_YOU_QUESTIONS: 6,
  REVIEW_APPLICATION: 7,
  PP_CC_POLICY_OUTCOME: 8,
  PP_CONTACT: 9,
  PP_CC_PAYMENT: 10,
  PP_CONFIRMATION: 11,
  PP_POLICY_OUTCOME_DECLINE: 12,
  /* Retrieve quote loading needs to be the last page in the index. We need the retrieve loading page to be present
   inside the ContactCenterLayout.jsx so that the initial state is kicked in and once we get retrieve information from API, then we add to the state
   Adding all the pages of outcome outside the sequence */
  RETRIEVE_QUOTE_LOADING: 13,
  RETRIEVE_DECLINE: 14,
  RETRIEVE_EXPIRED: 15,
  RETRIEVE_REFERRED_UW: 16,
  RETRIEVE_BOUND: 17,
  APPLICATION_ALREADY_DECLINED: 18,
  PP_CC_UPGRADE_SAVE_CONFIRMATION: 19,
};
